import './FileListBookmarks.scss';

export { default } from './FileListBookmarks';
